/*
 * Copyright (c) 2020 - 2025 Ping Identity Corporation. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */
import { BaseCallback } from './base-callback.js';
/**
 * Represents a callback used to integrate reCAPTCHA.
 */
export class ReCaptchaCallback extends BaseCallback {
    payload;
    /**
     * @param payload The raw payload returned by OpenAM
     */
    constructor(payload) {
        super(payload);
        this.payload = payload;
    }
    /**
     * Gets the reCAPTCHA site key.
     */
    getSiteKey() {
        return this.getOutputByName('recaptchaSiteKey', '');
    }
    /**
     * Sets the reCAPTCHA result.
     */
    setResult(result) {
        this.setInputValue(result);
    }
}
